export default "https://cdn-static.gokick.com/assets/a667d1dc3297954618d7ed7be4de1ad72d2b7ee9/images/sleep-tangerine.755ecdb6db700f77bb8084d276871abe.png";